import React from 'react';
import { Typography, Paper } from '@mui/material';

function AboutPage() {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>About Us</Typography>
      <Typography variant="body1" paragraph>
        Welcome to the Lost & Found portal. Our mission is to create a centralized platform to help people find their lost belongings and to help honest finders return items to their rightful owners.
      </Typography>
      <Typography variant="body1" paragraph>
        This platform connects individuals across communities, making the process of reporting and searching for lost or found items simple and efficient. We believe in the power of community and honesty to bring a little more order and happiness to our lives.
      </Typography>
    </Paper>
  );
}

export default AboutPage;